export const redirectLinks = {
    viewAllPatients: '/patients/all',
};